import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TYPOGRAPHY } from "@store/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

export interface AlternateScreenAndPrintViewStyles {
    wrapperScreen?: InjectableCss;
    wrapperPrint?: InjectableCss;
    wrapperPrintShell?: InjectableCss;
    zonePrintShell?: InjectableCss;
    shellContextText?: TypographyPresentationProps;
}

const wrapperPrint = css`
    position: relative;
    @media print {
        display: block;
        font-size: 12px !important;
        h1 {
            font-size: ${TYPOGRAPHY.size.largest} !important;
            font-weight: 500 !important;
        }
        h2 {
            font-size: ${TYPOGRAPHY.size.large} !important;
        }
    }
`;
export const alternateScreenAndPrintViewStyles: AlternateScreenAndPrintViewStyles = {
    wrapperScreen: {
        css: css`
            display: block;
            position: relative;
            @media print {
                display: none;
            }
        `,
    },
    wrapperPrint: {
        css: css`
            display: none;
            ${wrapperPrint}
        `,
    },
    wrapperPrintShell: {
        css: css`
            ${wrapperPrint}
            background: #e5e5e5;
            padding: 10px;
        `,
    },
    zonePrintShell: {
        css: css`
            background: ${getColor("common.background")};
        `,
    },
    shellContextText: {
        variant: "h6",
        css: css`
            margin: 0;
        `,
    },
};

const styles = alternateScreenAndPrintViewStyles;

const AlternateScreenAndPrintView: FC<WidgetProps> = props => {
    const shellContext = React.useContext(ShellContext);
    return (
        <>
            <StyledWrapper {...styles.wrapperScreen}>
                <Zone contentId={props.id} zoneName="ContentScreen" />
            </StyledWrapper>
            {shellContext.isEditing && (
                <StyledWrapper {...styles.wrapperPrintShell}>
                    <Typography>{translate("Print View")}</Typography>
                    <StyledWrapper {...styles.zonePrintShell}>
                        <Zone
                            contentId={props.id}
                            zoneName="ContentPrint"
                            {...(shellContext.isEditing ? styles.zonePrintShell : null)}
                        />
                    </StyledWrapper>
                </StyledWrapper>
            )}
            <StyledWrapper {...styles.wrapperPrint}>
                <Zone contentId={props.id} zoneName="ContentPrint" />
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: AlternateScreenAndPrintView,
    definition: {
        displayName: "Alternate Screen And Print View",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
